import { redirect } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { launchRouteRedirect } from "@/lib/launch-access";
import { trpc } from "@/lib/trpc";

// The `beforeLoad` every Launch route shares: viewers get no Launch route. The
// viewer's role is read from the cache entry the parent layout loaded, and
// anyone below member lands on Media Performance before any Launch loader runs.
export async function guardLaunchRoute({
  params,
  context,
}: {
  params: { orgSlug: string };
  context: { queryClient: QueryClient };
}) {
  const viewer = await context.queryClient.ensureQueryData(trpc.organization.viewer.queryOptions());
  const target = launchRouteRedirect(viewer, params.orgSlug);
  if (target) throw redirect(target);
}
